import { all } from 'redux-saga/effects'
import { saga as SimpleFetchManagerSaga } from 'loankeeper-common/helpers/SimpleFetchManager'

import { saga as DetailsContainerSaga } from './features/DetailsContainer/index'
import { saga as ClientFormSaga } from './features/ClientForm'
import { saga as FileDetailsSaga } from './features/FileDetails'
import { saga as LKGridSaga } from './features/shared/LKGrid'
import { saga as FilesGridSaga } from './features/FilesGrid'
import { saga as ConditionAddSaga } from './features/ConditionAdd'

// LoanDetail features here
import { saga as LoanDetailsOperationsSaga } from './features/LoanDetails/Info/OperationsTransactions'
import { saga as LoanDetailsScheduleSaga } from './features/LoanDetails/Info/Schedule'

// ClientDetail features here
import { saga as ClientDetailsCivilRegistrySaga } from './features/ClientDetails/Tabs/CivilRegistry'

import { saga as ReportingSaga } from './features/Reporting'

export default function* rootSaga() {
  yield all([
    ClientFormSaga(),

    DetailsContainerSaga(),

    FileDetailsSaga(),
    LKGridSaga(),
    FilesGridSaga(),

    ConditionAddSaga(),

    // LoanDetail features here
    LoanDetailsOperationsSaga(),
    LoanDetailsScheduleSaga(),

    // ClientDetail features here
    ClientDetailsCivilRegistrySaga(),

    SimpleFetchManagerSaga(),
    ReportingSaga(),
  ])
}
